export default __webpack_public_path__ + "static/media/business-main.8410d550.png";